import styled from "@emotion/styled"
import { Paper } from "@mui/material"
import React from "react"
import PbDeviceMarkerProps from "./PbDeviceMarkerProps.type"

const GPS_COLOR = "#F6EE81"
const EST_COLOR = "#3B89C7"

const DeviceMarker = styled(Paper)((props: PbDeviceMarkerProps) => ({
    width: props.width,
    aspectRatio: "1/1",
    backgroundColor: "#909090",
    margin: "5px 0",
    backgroundImage: props.imageSrc || "",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    border: "1px solid",
    borderColor: props.isGps ? GPS_COLOR : EST_COLOR,
    borderRadius: props.borderRadius,
    transform: "translate3d(-50%,-50%,0)"
}));

const PbDeviceMarker = (props: PbDeviceMarkerProps) => {
    return (
        <DeviceMarker onClick={props.handleOnClick} elevation={2} {...props}/>
    )
}

export default PbDeviceMarker;